import React from 'react'
import { arrayOf, string, shape, number } from 'prop-types'
import { Flex, Heading, Text } from 'rebass'
import citygateTheme from '../../theme/'
import typography from '../../utils/typography'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import LinkRounded from '../../components/LinkRounded'
import ContentBrandDerivativeSpecDetail from '../../components/ContentBrandDerivativeSpecDetail'
import {
  SpecBreakout,
  CenterCta,
  SpecDetail,
  TabWrapper,
  BasicLink,
  FlexWrapper,
  ConfiguartionBrandVw
} from './components/Spec'

import IconEngineDiesel from '../../vectors/IconEngineDiesel'
import IconEnginePetrol from '../../vectors/IconEnginePetrol'

const defaultSpecInfo = [
  { label: 'TSI', suffix: 'Petrol Engine', icon: <IconEngineDiesel /> },
  { label: 'TDI', suffix: 'Diesel Engine', icon: <IconEnginePetrol /> }
]

class ContentBrandDerivativeVanSpec extends React.PureComponent {
  constructor(props) {
    super(props)
    this.myCountUp = null
    this.state = {
      tabIndex: 0
    }
  }

  render() {
    return (
      <TabWrapper mx={'8%'} bg={citygateTheme.colors.blue}>
        <Heading mb={50} fontSize={[5, 6, 7]}>
          Choose your configuration below
        </Heading>
        <Tabs
          selectedIndex={this.state.tabIndex}
          onSelect={(tabIndex) => this.setState({ tabIndex })}
        >
          <FlexWrapper flexWrap="wrap">
            <TabList>
              {this.props.items.map((item, key) => (
                <Tab key={`bdspec:${key}:${item.heading}`}>
                  <BasicLink>{item.heading}</BasicLink>
                </Tab>
              ))}
            </TabList>
          </FlexWrapper>
          {this.props.items.map((item, key) => (
            <TabPanel key={`tpbds:${key}:${item.model}:${item.engine}`}>
              <Flex
                flexWrap="wrap"
                pt={[typography.rhythm(2), null, typography.rhythm(2.5)]}
              >
                <SpecDetail
                  width={[12 / 12, null, 6 / 12]}
                  mx={['auto', null, 'initial']}
                >
                  <Heading as="h2" fontSize={7}>
                    {item.heading}
                  </Heading>
                  {item.subheading && (
                    <Text
                      as="span"
                      fontSize={5}
                      color={citygateTheme.colors.blue_light_op50}
                      bold
                    >
                      {item.subheading}
                    </Text>
                  )}
                  {item.description && (
                    <Text mt={typography.rhythm(0.5)}>{item.description}</Text>
                  )}
                  {item.options && (
                    <Text
                      bold
                      mt={typography.rhythm(0.5)}
                      mb={[0, null, typography.rhythm(2)]}
                    >
                      {item.options}
                    </Text>
                  )}
                </SpecDetail>
                <SpecBreakout width={[1 / 1, null, 5 / 12]} ml="auto">
                  <Flex flexWrap="wrap">
                    <ContentBrandDerivativeSpecDetail
                      key={`tpcbdsd:${key}`}
                      spec={
                        item.images
                          ? [{ image: item.images[0] }]
                          : defaultSpecInfo
                      }
                    />
                  </Flex>
                </SpecBreakout>
              </Flex>
              {item.configurationUrl && (
                <Flex
                  flexWrap="wrap"
                  pt={[typography.rhythm(2), null, 0]}
                  pb={[typography.rhythm(2), null, typography.rhythm(2.5)]}
                >
                  <CenterCta width={[12 / 12, null, 6 / 12]}>
                    <LinkRounded
                      hrefontSize={item.configurationUrl}
                      eventCategory="StartConfigurator"
                      reversed
                      shadow
                    >
                      <ConfiguartionBrandVw />
                      Start configuration
                    </LinkRounded>
                  </CenterCta>
                </Flex>
              )}
            </TabPanel>
          ))}
        </Tabs>
      </TabWrapper>
    )
  }
}

ContentBrandDerivativeVanSpec.defaultProps = {
  items: [],
  currency: { code: 'GBP', symbol: '£' }
  // make: {short: '', long: ''}
}

ContentBrandDerivativeVanSpec.propTypes = {
  items: arrayOf(
    shape({
      jj: string,
      model: string,
      derivative: string,
      engine: string,
      summary: string,
      options: string,
      price: shape({
        total: number,
        reserve: number,
        installment: shape({
          payment: number,
          plan: string,
          code: string
        })
      }),
      dimensions: arrayOf(
        shape({
          value: number,
          decimal: number,
          heading: string,
          suffix: string
        })
      )
    })
  )
}

export default ContentBrandDerivativeVanSpec
